module.exports = JSON.parse('{"X":["JP","TH","ID","MY","TW","KR","PH","IN","VN"]}')